var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapDance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3155)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#C071FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2637_3155",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 40,
    width: 34,
    height: 35,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 40,
    y: 40,
    width: 34,
    height: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2605 54.4121L66.4915 51.1811C68.5138 49.1588 68.5138 45.8736 66.4915 43.8513L59.5956 50.7472V46.1835C59.5956 43.3167 57.2712 41 54.4121 41V50.7472L51.1811 47.5162C49.1588 45.4939 45.8736 45.4939 43.8513 47.5162L50.7472 54.4121H46.1835C43.3167 54.4121 41 56.7366 41 59.5956H50.7395L47.5085 62.8266C45.4862 64.8489 45.4862 68.1341 47.5085 70.1564L54.4044 63.2605V67.8242C54.4044 70.691 56.7288 73.0077 59.5879 73.0077V63.2605L62.8189 66.4915C64.8412 68.5138 68.1264 68.5138 70.1487 66.4915L63.2528 59.5956H67.8165C70.6833 59.5956 73 57.2712 73 54.4121H63.2605Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2605 54.4121L66.4915 51.1811C68.5138 49.1588 68.5138 45.8736 66.4915 43.8513L59.5956 50.7472V46.1835C59.5956 43.3167 57.2712 41 54.4121 41V50.7472L51.1811 47.5162C49.1588 45.4939 45.8736 45.4939 43.8513 47.5162L50.7472 54.4121H46.1835C43.3167 54.4121 41 56.7366 41 59.5956H50.7395L47.5085 62.8266C45.4862 64.8489 45.4862 68.1341 47.5085 70.1564L54.4044 63.2605V67.8242C54.4044 70.691 56.7288 73.0077 59.5879 73.0077V63.2605L62.8189 66.4915C64.8412 68.5138 68.1264 68.5138 70.1487 66.4915L63.2528 59.5956H67.8165C70.6833 59.5956 73 57.2712 73 54.4121H63.2605Z",
    fill: "#C071FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2605 54.4121L66.4915 51.1811C68.5138 49.1588 68.5138 45.8736 66.4915 43.8513L59.5956 50.7472V46.1835C59.5956 43.3167 57.2712 41 54.4121 41V50.7472L51.1811 47.5162C49.1588 45.4939 45.8736 45.4939 43.8513 47.5162L50.7472 54.4121H46.1835C43.3167 54.4121 41 56.7366 41 59.5956H50.7395L47.5085 62.8266C45.4862 64.8489 45.4862 68.1341 47.5085 70.1564L54.4044 63.2605V67.8242C54.4044 70.691 56.7288 73.0077 59.5879 73.0077V63.2605L62.8189 66.4915C64.8412 68.5138 68.1264 68.5138 70.1487 66.4915L63.2528 59.5956H67.8165C70.6833 59.5956 73 57.2712 73 54.4121H63.2605Z",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_2637_3155)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3155",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3155"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3155",
    x: 36,
    y: 40,
    width: 42,
    height: 42.0078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3155",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapDance);
export default __webpack_public_path__ + "static/media/glowing_map_dance.fde2811c03964981da5fd24e18fa3001.svg";
export { ForwardRef as ReactComponent };